
function Home() {
	return (
		<main className={" flex flex-col justify-between items-center"}>
			Home
		</main>
	);
}

export default Home;